import Vue from 'vue';
import Vuex from 'vuex';
import navigationDrawer from './navigationDrawer';
import database from './database';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    navigationDrawer,
    database,
  },
  state: {},
  mutations: {},
  actions: {},
});
